// utils/mapEvents.js
import { useMapEvents } from "react-leaflet";

const MapEvents = ({ onBoundsChange }) => {
	useMapEvents({
		moveend: (e) => {
			const map = e.target;
			const bounds = map.getBounds();
			const center = map.getCenter();

			onBoundsChange({
				ne: bounds.getNorthEast(),
				sw: bounds.getSouthWest(),
				center: {
					lat: center.lat,
					lng: center.lng,
				},
			});
		},
	});

	return null;
};

export default MapEvents;
